import { render, staticRenderFns } from "./foodhistory.vue?vue&type=template&id=7c25ddfe&scoped=true&"
import script from "./foodhistory.vue?vue&type=script&lang=js&"
export * from "./foodhistory.vue?vue&type=script&lang=js&"
import style0 from "./foodhistory.vue?vue&type=style&index=0&id=7c25ddfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c25ddfe",
  null
  
)

export default component.exports